import type { ReactNode } from 'react';

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: Props) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <i className="ri-bookmark-3-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action}
    </div>
  );
}